export default "__VITE_ASSET__DOIiJXII__"